import { useContent } from "@/content/ContentContext";

export default function EditorialMarquee() {
  const { content } = useContent();
  const row = [...content.marquee, ...content.marquee];
  return (
    <div
      className="relative border-y border-[rgba(212,175,55,0.18)] bg-[#0A0A0C] py-6 overflow-hidden"
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      <div className="marquee-track items-center gap-10 pr-10">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10 shrink-0">
            <span className="font-serif-lux italic text-2xl sm:text-3xl text-[#8d8d99] whitespace-nowrap hover:text-gold-champagne transition-colors duration-500">
              {item}
            </span>
            <span className="text-gold text-sm">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
